/**
 * Slideshow Whole Slide Link
 * Makes a slide with a "Whole slide link" setting clickable anywhere,
 * while letting buttons/links/inputs inside the slide keep working normally.
 */

(function () {
  function isInteractiveTarget(target) {
    return !!target.closest('a, button, input, textarea, select, label');
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;

    var slide = event.target.closest('.slideshow__slide[data-slide-link]');
    if (!slide) return;
    if (isInteractiveTarget(event.target)) return;

    var url = slide.getAttribute('data-slide-link');
    if (url) {
      window.location.href = url;
    }
  });
})();
